import { Warehouse } from '../models/models'
import backendConnection from './util/backend-connection'
import { Response } from './util/with-response-formatter-interceptor'

export const getWarehouses = (): Promise<Response<Warehouse[]>> =>
    backendConnection.request({
        url: `/warehouse`,
        method: 'GET',
    })
